export const getRandomFromList = (list) => {
  return list[Math.round(Math.random() * (list.length - 1))];
};
